import { CategoriesSlider } from "./categoryList";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { useCallback, useEffect, useRef } from "react";
import { BackBarButtonMini } from "../common/backBarButton";
import smoothScroll from "../../utils/animateScroll";
import {
  getPaginationFocusEdge,
  getVerticalFocusScrollTarget,
} from "../../utils/focusScroll";
import { useCategoryContentList } from "../../utils/hooks/useCategory";
import { useInputMode } from "../../utils/hooks/useInputMode";

var GenreContent = function (props) {
  var data = props.data;
  var slug = props.slug;
  var contentKind = props.contentKind;

  var focusableResult = useFocusable();
  var ref = focusableResult.ref;
  var focusKey = focusableResult.focusKey;

  var categoryHook = useCategoryContentList({
    fetchDelay: 0,
    slug: slug,
    initialPage: 1,
    pageSize: 20,
    // When contentKind is set, skip unfiltered initial data and auto-fetch from content endpoint
    autoInit: !!contentKind,
    initialData: contentKind ? [] : (data?.contents?.[0]?.data || []),
    lazyLoading: false,
    kind: "genre",
    contentKind: contentKind,
  });

  var items = categoryHook.items;
  var hasMore = categoryHook.hasMore;
  var onLoadMore = categoryHook.onLoadMore;
  var isLoading = categoryHook.isLoading;

  var sentinelRef = useRef();
  var { isMouseFocus } = useInputMode();

  var loadMoreRef = useRef(null);
  loadMoreRef.current = function () {
    if (hasMore && !isLoading) {
      onLoadMore();
    }
  };

  var onRowFocus = useCallback(
    function (focusProps) {
      if (isMouseFocus) return;
      if (!ref.current) return;

      var targetScroll = getVerticalFocusScrollTarget(ref.current, focusProps || {}, {
        topPadding: 88,
        bottomPadding: 128,
        align: "center",
      });

      smoothScroll(ref, targetScroll, 300);

      if (getPaginationFocusEdge(ref.current, focusProps || {}, 160) > 0) {
        loadMoreRef.current?.();
      }
    },
    [ref, isMouseFocus]
  );

  useEffect(
    function () {
      var scrollContainer = ref.current;
      var sentinel = sentinelRef.current;
      if (!scrollContainer || !sentinel) return;

      var marginPx = Math.round(window.innerHeight * 0.1);
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (entry.isIntersecting) {
            loadMoreRef.current?.();
          }
        },
        { root: scrollContainer, rootMargin: '0px 0px ' + marginPx + 'px 0px', threshold: 0.1 }
      );

      observer.observe(sentinel);

      return function () {
        observer.unobserve(sentinel);
      };
    },
    [items.length]
  );

  return (
    <div className="legacy-paged-content">
      <FocusContext.Provider value={focusKey}>
        <div className="legacy-paged-header">
          <BackBarButtonMini />
          <h2 className="legacy-paged-title">{data.result.name}</h2>
        </div>
        <div className="legacy-paged-scroll" ref={ref}>
          {items.length > 0 ? (
            <CategoriesSlider
              rowTitle=""
              movies={items}
              onFocus={onRowFocus}
              nextPlayGuide={{
                type: "genre",
                slug: slug,
                name: data?.result?.name || "",
              }}
            />
          ) : !isLoading ? (
            <div className="legacy-paged-empty">
              <span className="legacy-paged-empty-text">محتوایی یافت نشد</span>
            </div>
          ) : null}
          {isLoading && (
            <div className="legacy-paged-loading">
              <span className="legacy-paged-loading-text">در حال بارگذاری...</span>
            </div>
          )}
          <div className="legacy-paged-sentinel" ref={sentinelRef} />
        </div>
      </FocusContext.Provider>
    </div>
  );
};

export default GenreContent;
